// extracted by mini-css-extract-plugin
export var clauseRow = "_ff-6";
export var emptyState = "_ff-d";
export var filterContent = "_ff-a";
export var filterGroup = "_ff-1";
export var filterGroupContainer = "_ff-0";
export var nestedGroup = "_ff-2";
export var nestedGroupContent = "_ff-b";
export var nestedGroupDepth1 = "_ff-3";
export var nestedGroupDepth2 = "_ff-4";
export var nestedGroupDepth3 = "_ff-5";
export var nestedGroupEmpty = "_ff-c";
export var operatorAnd = "_ff-8";
export var operatorOr = "_ff-9";
export var operatorToggle = "_ff-7";
export var removeGroupButton = "_ff-e";